export enum ToolIdsEnum {
  DRAW = 'draw',
  INFO = 'info',
  REPORT = 'report',
  NONE = '',
}
